import { StateCreator } from 'zustand'
import type { FFEStore } from '../types'
import type { Supplier } from '../../types/ffe'

export interface SuppliersSlice {
  addSupplier: (supplier: Supplier) => void
  removeSupplier: (supplier: Supplier) => void
  updateSupplier: (supplier: Supplier) => void
  setSuppliers: (suppliers: Supplier[]) => void
  setLoadingSuppliers: (loading: boolean) => void
}

export const createSuppliersSlice: StateCreator<
  FFEStore,
  [],
  [],
  SuppliersSlice
> = (set) => ({
  addSupplier: (supplier) => {
    set((state) => ({
      suppliers: [...state.suppliers, supplier]
    }))
  },
  removeSupplier: (supplier) => {
    set((state) => ({
      suppliers: state.suppliers.filter((s) => s._id !== supplier._id)
    }))
  },
  updateSupplier: (supplier) => {
    set((state) => ({
      suppliers: state.suppliers.map((s) =>
        s._id === supplier._id ? supplier : s
      )
    }))
  },
  setSuppliers: (suppliers) => {
    set(() => ({
      suppliers
    }))
  },
  setLoadingSuppliers: (loading) => {
    set(() => ({
      loadingSuppliers: loading
    }))
  }
})
